var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSkipIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1919 5V15H13.9419V5H15.1919ZM12.8003 10L4.80811 14.9912V5.00879L12.8003 10ZM6.05811 12.7334L10.4419 9.99121L6.05811 7.25V12.7334Z",
    fill: "#FFED00"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSkipIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Skip_Icon.fa8a03690a8844801af008e25a084e4f.svg";